import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IframeCommunication } from 'src/app/shared/services/iframe-communication/iframe-communication.helper';

@Injectable({
  providedIn: 'root',
})
export class AuthHelperService {
  iframeRefreshToken$ = new Subject<IframeCommunication.MessageName>();
}
